export default __webpack_public_path__ + "static/media/lomecan.f24cc083.png";